import { render, staticRenderFns } from "./Activity.vue?vue&type=template&id=580f457c&scoped=true&"
import script from "./Activity.vue?vue&type=script&lang=js&"
export * from "./Activity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580f457c",
  null
  
)

component.options.__file = "Activity.vue"
export default component.exports